// extracted by mini-css-extract-plugin
export default {"icon":"forwardLink_icon__mdyLg"};